import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Critical Components (loaded immediately)
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import StructuredData from "./components/StructuredData";

// Lazy-loaded Components (loaded when needed)
const Footer = React.lazy(() => import("./components/Footer"));
const Home = React.lazy(() => import("./pages/Home"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const About = React.lazy(() => import("pages/About"));
const ServicesDR = React.lazy(() => import("pages/ServicesDR"));
const Contact = React.lazy(() => import("pages/Contact"));
const ServicesDRSpecility = React.lazy(
  () => import("pages/ServicesDetailPages/ServicesDRSpecility")
);
const Review = React.lazy(() => import("pages/Review"));
const Accessibility = React.lazy(() => import("pages/Accesability"));
const ArabicLanding = React.lazy(() => import("pages/ArabicLanding"));
const Conditions = React.lazy(() => import("pages/Conditions"));
const ConditionDetail = React.lazy(() => import("pages/ConditionDetail"));

// Loading component for Suspense
const LoadingFallback: React.FC = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "200px" }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">טוען...</span>
    </div>
  </div>
);

const AppContent: React.FC = () => {
  // const { isModalOpen, closeModal } = useOdoroModal();

  // The Arabic landing page (/ar) is a self-contained RTL Arabic experience
  // with its own header/footer - the Hebrew Navbar/Footer are hidden there.
  const { pathname } = useLocation();
  const isArabicPage = pathname === "/ar";

  return (
    <>
      {/* Global Structured Data for SEO */}
      <StructuredData domain="https://mulla-neurospine.co.il" />

      <ScrollToTop />

      {!isArabicPage && <Navbar />}

      <div className="app-container d-flex flex-column min-vh-100">
        <main className="flex-grow-1">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services-dr" element={<ServicesDR />} />
              <Route
                path="/services-dr/specility/:serviceId"
                element={<ServicesDRSpecility />}
              />
              {/* <Route path="/debug-data" element={<DebugData />} /> */}

              <Route path="/conditions" element={<Conditions />} />
              <Route
                path="/conditions/:conditionId"
                element={<ConditionDetail />}
              />

              <Route path="/contact" element={<Contact />} />
              <Route path="/review" element={<Review />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/ar" element={<ArabicLanding />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        {!isArabicPage && (
          <Suspense fallback={<div style={{ minHeight: "100px" }} />}>
            <Footer />
          </Suspense>
        )}

        {/* Odoro Modal - Disabled */}
        {/* <OdoroModal show={isModalOpen} onHide={closeModal} /> */}
      </div>
    </>
  );
};

const App: React.FC = () => {
  return (
    // <OdoroModalProvider>
    <AppContent />
    // </OdoroModalProvider>
  );
};

export default App;
